import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { BenefitsCardVal } from "../../stories/BenefitsCard.stories";
import Loading from "../../common/Loading";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const FamilyDashboardBenefits = (props) => {
  let { uuid } = useParams();
  const [loadingspinner, setLoadingspinner] = useState(true);

  useEffect(() => {
    if (props.allData) {
      setLoadingspinner(false);
    }
  }, [props.allData]);

  return (
    <>
      <div className="mb-3 d-flex">
        <h2 className="me-auto mb-0">Discounts</h2>
        <Link
          className="btn btn-white btn-sm btn-circle flex-shrink-0"
          to={uuid ? `/discounts/${uuid}` : "#"}
        >
          <i className="fa-solid fa-sm fa-angle-right text-dark"></i>
        </Link>
      </div>
      {loadingspinner ? (
        <>
          <div className="loadind-page">
            <Loading />
          </div>
        </>
      ) : (
        <>
          <div className="d-flex">
            <div className="d-flex py-4 align-items-center justify-content-center bg-white rounded-4">
              <div>
                <h1
                  className="text-center font-semibold text-lg"
                  style={{ color: "#36f1cc", fontSize: "32px" }}
                >
                  Coming Soon!
                </h1>
                <p>
                  <span className="text-dark d-block text-center">
                    for Elderly Life
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* {props.allData.discountsData.length === 0 ? (
            <p className="small mb-0">You currently have no discounts!</p>
          ) : (
            <>
              {props.allData.discountsData.map(
                ({ benefitText, logoImg, ctaText, benefitUrl }) => (
                  <>
                    <hr className="my-3" />

                    <div
                      className={`card-body card p-0 card-unstyled
                        `}
                    >
                      <div className="d-flex align-items-center mb-2">
                        <img
                          className="img-third-party-logo img-third-party-logo-xs me-auto rounded-circle "
                          src={logoImg}
                          alt="logo"
                          style={{ border: "1px solid #d9d9d9" }}
                        />
                      </div>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250 }}
                        overlay={
                          <Tooltip id="">
                            <div className="">{benefitText}</div>
                          </Tooltip>
                        }
                      >
                        <div
                          className="h5 mb-1"
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            WebkitLineClamp: 2,
                            cursor: "pointer",
                          }}
                        >
                          {benefitText}
                        </div>
                      </OverlayTrigger>
                      <div
                        className="small text-body"
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: 1,
                          cursor: "pointer",
                        }}
                      >
                        {ctaText}
                      </div>

                      <a
                        className=""
                        href={benefitUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="btn btn-primary my-5 w-100">
                          {" "}
                          Get discount
                        </div>
                      </a>
                    </div>
                  </>
                )
              )}
            </>
          )} */}
        </>
      )}
    </>
  );
};

export default FamilyDashboardBenefits;
